export const SURVEY_QUESTION_TYPES = {
  singleChoice: 'single-choice',
  multipleChoice: 'multiple-choice',
  shortInput: 'short-input',
  longInput: 'long-input'
}
